<script setup lang="ts">
  import { MpIcon, MpText, MpCard } from '@borg/ui';

  const job = jobRepository.use();
  const date = computed(() =>
    job.value?.userInfo.appliedAt ? job.value.userInfo.appliedAt : null,
  );
</script>

<template>
  <MpCard
    v-if="date"
    border
    class="notification"
  >
    <MpIcon icon="check_mark" />
    <div>
      <MpText
        semibold
        no-margin
      >
        {{ $t('JOB_CARD.APPLICATION_SENT_LABEL', { date: $d(date, 'dmy') }) }}
        {{ ' ' }}
      </MpText>
      <ChooseApplicationTypeButton
        v-if="job?.isActive"
        source="details_applied_tooltip"
      >
        <template #default="{ onContinue }">
          <MpText
            link
            @click="onContinue"
          >
            {{ $t('JOB_CARD.SEND_UPDATED_APPLICATION_LABEL') }}
          </MpText>
        </template>
      </ChooseApplicationTypeButton>
    </div>
  </MpCard>
</template>

<style scoped lang="scss">
  .notification {
    display: flex;
    align-items: center;
    gap: var(--mp-space-30);
    color: var(--mp-color-primary-default);
  }
</style>
